import { z } from 'zod'
import type { Json } from '../services/supabase/database.types'
import { ROLES, STATUS_ITEM, STATUS_REQUISICAO } from '../types/domain'

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
const timestamp = z.string().datetime({ offset: true })
const nullableText = z.string().nullable()

export const roleSchema = z.enum(ROLES)
export const statusRequisicaoSchema = z.enum(STATUS_REQUISICAO)
export const statusItemSchema = z.enum(STATUS_ITEM)

export const profileSchema = z.object({
  id: z.uuid(),
  role: roleSchema,
  nome: z.string().trim().min(1),
  email: z.email().nullable(),
  ativo: z.boolean(),
  created_at: timestamp,
  updated_at: timestamp,
})

export const requisicaoSchema = z.object({
  id: z.uuid(),
  numero_requisicao: z.string().trim().min(1),
  data_requisicao: isoDate,
  obra: nullableText,
  setor: nullableText,
  requisitante_id: z.uuid().nullable(),
  requisitante_nome: z.string().trim().min(1),
  status_geral: statusRequisicaoSchema,
  justificativa: nullableText,
  solicitante_nome: nullableText,
  responsavel_nome: nullableText,
  bloqueada: z.boolean(),
  versao: z.number().int().positive(),
  created_at: timestamp,
  updated_at: timestamp,
  deleted_at: timestamp.nullable(),
  deleted_by: z.uuid().nullable(),
})

export const historicoSchema = z.object({
  id: z.uuid(),
  requisicao_id: z.uuid().nullable(),
  item_id: z.uuid().nullable(),
  usuario_id: z.uuid().nullable(),
  usuario_nome: nullableText,
  usuario_role: roleSchema.nullable(),
  evento: z.string().trim().min(1),
  dados_anteriores: z.custom<Json>().nullable(),
  dados_novos: z.custom<Json>().nullable(),
  origem: z.string().trim().min(1),
  created_at: timestamp,
})

export const requisicaoItemSchema = z.object({
  id: z.uuid(),
  item_catalogo_id: z.uuid().nullable(),
  requisicao_id: z.uuid(),
  codigo: nullableText,
  descricao: z.string().trim().min(1),
  grade1: nullableText,
  grade2: nullableText,
  grade3: nullableText,
  unidade: nullableText,
  quantidade_solicitada: z.number().positive(),
  necessidade: nullableText,
  prioridade: nullableText,
  quantidade_comprada: z.number().nonnegative().nullable(),
  fornecedor: nullableText,
  prazo_entrega: isoDate.nullable(),
  status_item: statusItemSchema,
  observacao_comprador: nullableText,
  versao: z.number().int().positive(),
  created_at: timestamp,
  updated_at: timestamp,
  deleted_at: timestamp.nullable(),
  deleted_by: z.uuid().nullable(),
})
